import { Card, CardBody, Col } from "reactstrap";
import { DefaultRatioTitle } from "../../../Constants/Constants";
import { DefaultRatioSubTitle } from "../../../Data/BonusUi/Ratios";
import CommonCardHeader from "../../CommonComponents/CommonCardHeader/CommonCardHeader";

const DefaultRatio = () => {
  return (
    <Col lg="6">
      <Card>
        <CommonCardHeader title={DefaultRatioTitle} span={DefaultRatioSubTitle} />
        <CardBody>
          <div className="ratio ratio-16x9">
            <iframe src="https://www.youtube.com/embed/qDL2HBPy9uQ?si=yyIowrbZW-C-3lxd" title="YouTube video" allowFullScreen />
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};

export default DefaultRatio;
